import { SelectMemberTypeEnum, SortTypeProps } from '@modules/teams/teams.types';
import { capitalize } from '@shared/utils/capitalize';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { RiArrowDownSLine, RiVerifiedBadgeFill } from 'react-icons/ri';

export function SortMemberType({ onChange }: SortTypeProps) {
  const { t } = useTranslation();
  return (
    <Select
      placeholder={t('sort_by').toUpperCase()}
      variant="borderless"
      popupMatchSelectWidth={200}
      size="small"
      suffixIcon={<RiArrowDownSLine />}
      className="bg-white rounded-4xl placeholder:text-slate-950! font-semibold px-2! border border-gray-800 h-7!"
      onChange={onChange}
      classNames={{ popup: { root: 'prevent-click-outside' } }}
      menuItemSelectedIcon={<RiVerifiedBadgeFill />}
      options={[
        { label: capitalize(t('recently_added')), value: SelectMemberTypeEnum.createdAt },
        { label: capitalize(t('recently_active')), value: SelectMemberTypeEnum.lastSeenAt },
        { label: capitalize(t('name_a_to_z')), value: SelectMemberTypeEnum.name },
      ]}
    />
  );
}
